import { Tooltip } from '@mui/material';
import { FormikProps } from 'formik';
import React from 'react';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

import trashSvg from '../../../../../assets/img/trash.svg';
import { TestTaskFormikValues } from '../../TestTask';

interface Props {
  testTaskFormik: FormikProps<TestTaskFormikValues>;
}

export const TestItemsList = ({ testTaskFormik }: Props) => {
  const { t } = useTranslation();

  const removeTestItem = (id: string) => {
    const filteredTestItems = testTaskFormik.values.testItems.filter(testItem => testItem.id !== id);
    testTaskFormik.setFieldValue('testItems', filteredTestItems);
    toast.success(t('task option successfully removed'));
  };

  return (
    <ul className="flex flex-col !gap-4">
      {testTaskFormik.values.testItems.map((testItem, index) => (
        <li key={testItem.id} className="flex flex-col justify-between !gap-3 lg:flex-row lg:items-center">
          <div
            className={`flex flex-col items-start !gap-3 !px-3 !py-2 lg:flex-row lg:items-center ${testItem.isRight && 'w-full rounded-lg border !border-[#08B781] bg-[#D3F8E7]'}`}
          >
            <p className="!mb-0 text-lg font-medium leading-[24px]">{`${index + 1}. `}</p>
            <p className="!mb-0 text-base font-semibold">{testItem.text}</p>
          </div>

          <Tooltip
            title={t('delete')}
            componentsProps={{
              popper: {
                sx: {
                  ['& .MuiTooltip-arrow']: {
                    color: '#9CDFFC',
                  },
                  ['& .MuiTooltip-tooltip']: {
                    backgroundColor: '#9CDFFC',
                    color: '#000000',
                    fontSize: '14px',
                    padding: '14px',
                    borderRadius: '8px',
                  },
                },
              },
            }}
            arrow
          >
            <button
              className="btn more small h-[40px] w-[40px] rounded-[8px] !p-[6px] text-red-600"
              onClick={() => removeTestItem(testItem.id)}
            >
              <img src={trashSvg} alt="remove" />
            </button>
          </Tooltip>
        </li>
      ))}
    </ul>
  );
};
